"use client";

import { useEffect } from "react";

const MOBILE_QUERY = "(max-width: 767px)";

export function AppShellViewportLock() {
  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const mq = window.matchMedia(MOBILE_QUERY);

    let applied = false;
    let saved: {
      htmlHeight: string;
      htmlOverflow: string;
      htmlOverscroll: string;
      bodyHeight: string;
      bodyOverflow: string;
      bodyOverscroll: string;
      bodyTouchAction: string;
      bodyPosition: string;
      bodyTop: string;
      bodyLeft: string;
      bodyRight: string;
      bodyWidth: string;
    } | null = null;

    const preventGesture = (e: Event) => e.preventDefault();

    const apply = () => {
      if (applied) return;
      saved = {
        htmlHeight: html.style.height,
        htmlOverflow: html.style.overflow,
        htmlOverscroll: html.style.overscrollBehavior,
        bodyHeight: body.style.height,
        bodyOverflow: body.style.overflow,
        bodyOverscroll: body.style.overscrollBehavior,
        bodyTouchAction: body.style.touchAction,
        bodyPosition: body.style.position,
        bodyTop: body.style.top,
        bodyLeft: body.style.left,
        bodyRight: body.style.right,
        bodyWidth: body.style.width,
      };
      html.style.height = "100svh";
      html.style.overflow = "hidden";
      html.style.overscrollBehavior = "none";
      body.style.height = "100svh";
      body.style.overflow = "hidden";
      body.style.overscrollBehavior = "none";
      body.style.touchAction = "pan-y";
      // iOS Safari ignores `overscroll-behavior: none` at the document level, so
      // the page still rubber-bands a few px even with the above (Android Chrome
      // honors it — hence the platform difference). Pinning <body> with
      // position:fixed removes the document scroll entirely; the shell's own
      // overflow-y-auto region handles all scrolling instead.
      body.style.position = "fixed";
      body.style.top = "0";
      body.style.left = "0";
      body.style.right = "0";
      body.style.width = "100%";
      document.addEventListener("gesturestart", preventGesture);
      document.addEventListener("gesturechange", preventGesture);
      document.addEventListener("gestureend", preventGesture);
      applied = true;
    };

    const restore = () => {
      if (!applied || !saved) return;
      html.style.height = saved.htmlHeight;
      html.style.overflow = saved.htmlOverflow;
      html.style.overscrollBehavior = saved.htmlOverscroll;
      body.style.height = saved.bodyHeight;
      body.style.overflow = saved.bodyOverflow;
      body.style.overscrollBehavior = saved.bodyOverscroll;
      body.style.touchAction = saved.bodyTouchAction;
      body.style.position = saved.bodyPosition;
      body.style.top = saved.bodyTop;
      body.style.left = saved.bodyLeft;
      body.style.right = saved.bodyRight;
      body.style.width = saved.bodyWidth;
      document.removeEventListener("gesturestart", preventGesture);
      document.removeEventListener("gesturechange", preventGesture);
      document.removeEventListener("gestureend", preventGesture);
      applied = false;
      saved = null;
    };

    const sync = (matches: boolean) => (matches ? apply() : restore());
    sync(mq.matches);

    const onChange = (e: MediaQueryListEvent) => sync(e.matches);
    mq.addEventListener("change", onChange);

    return () => {
      mq.removeEventListener("change", onChange);
      restore();
    };
  }, []);

  return null;
}
